import {FormControl, FormHelperText, FormLabel, Input, TextField, Typography} from "@mui/material";
import { Controller } from "react-hook-form";

export default function TextInput({name, control, helper, errors, question, required}) {

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={''}
            render={({ field : {onBlur, ...field} }) =>
            <FormControl fullWidth error={errors? true : false}>
                <FormLabel required={required}>{question}</FormLabel>
                {helper? helper.map(text => (
                    <FormHelperText key={text} className="wrap-it helper">{text}</FormHelperText>
                )) : null}
                <TextField multiline {...field} onBlur={onBlur}/>
                <Typography className="font-14 error-message">
                {errors?.message}
                </Typography>
            </FormControl>}
        />
    );
}